Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _useTypeStyles2 = require("./useTypeStyles");
var _props = require("../../props");
var _reactNative = require("react-native-web");
var _useSharedStyles2 = require("./useSharedStyles");
var _useNativeContainerStyles = require("./useNativeContainerStyles");
var useStyles = exports.useStyles = function useStyles(_ref) {
  var type = _ref.type,
    size = _ref.size,
    state = _ref.state,
    isFocused = _ref.isFocused,
    isPointerOver = _ref.isPointerOver;
  var _useTypeStyles = (0, _useTypeStyles2.useTypeStyles)(),
    typeStyles = _useTypeStyles.typeStyles;
  var _useSharedStyles = (0, _useSharedStyles2.useSharedStyles)(),
    sharedStyles = _useSharedStyles.sharedStyles;
  var _useNativeContainerSt = (0, _useNativeContainerStyles.useNativeContainerStyles)({
      size: size
    }),
    nativeContainerStyles = _useNativeContainerSt.nativeContainerStyles;
  var _hasType = !!type;
  var _hasSize = !!size;
  var _isDisabled = (state == null ? void 0 : state.disabled) || false;
  var label = [_hasType && typeStyles[type].label];
  var nativeContainer = [];
  switch (type) {
    case _props.ButtonType.normal:
      label.push(sharedStyles.label);
      _hasSize && label.push(sharedStyles["label_".concat(size)]);
      nativeContainer.push(nativeContainerStyles);
      break;
    case _props.ButtonType.alternative:
      label.push(sharedStyles.label);
      _hasSize && label.push(sharedStyles["label_".concat(size)]);
      nativeContainer.push(nativeContainerStyles);
      break;
    case _props.ButtonType.brand:
      label.push(sharedStyles.label);
      _hasSize && label.push(sharedStyles["label_".concat(size)]);
      nativeContainer.push(nativeContainerStyles);
      break;
    case _props.ButtonType.icon:
    case _props.ButtonType.iconOutlined:
      label.push(sharedStyles.label);
      _hasSize && label.push(typeStyles[type][size]);
      nativeContainer.push(nativeContainerStyles);
      break;
    case _props.ButtonType.outlined:
      label.push(sharedStyles.label);
      _hasSize && label.push(sharedStyles["label_".concat(size)]);
      nativeContainer.push(nativeContainerStyles);
      break;
    case _props.ButtonType.link:
    case _props.ButtonType.brandLink:
      _hasSize && label.push(typeStyles[type][size]);
      break;
  }
  _isDisabled && label.push(sharedStyles.disabled);
  if (isFocused) {
    var _typeStyles$type;
    label.push(sharedStyles.focused);
    if (_hasType && (_typeStyles$type = typeStyles[type]) != null && _typeStyles$type.focused) {
      label.push(typeStyles[type].focused);
    }
  }
  if (isPointerOver) {
    var _typeStyles$type2;
    if (_hasType && (_typeStyles$type2 = typeStyles[type]) != null && _typeStyles$type2.pointerOver) {
      label.push(typeStyles[type].pointerOver);
    }
  }
  var styles = _reactNative.StyleSheet.create({
    label: Object.assign.apply(Object, [{}].concat(label)),
    nativeContainer: Object.assign.apply(Object, [{}].concat(nativeContainer))
  });
  return {
    styles: styles
  };
};